/** Routing table. */

import { Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';

import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';
import { AboutPage } from './pages/AboutPage';
import { AuthPage } from './pages/AuthPage';
import { CategoriesPage } from './pages/CategoriesPage';
import { CompanyPage } from './pages/CompanyPage';
import { DashboardPage } from './pages/DashboardPage';
import { ForEmployersPage } from './pages/ForEmployersPage';
import { HomePage } from './pages/HomePage';
import { JobPage } from './pages/JobPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PostFinishPage } from './pages/PostFinishPage';
import { PostPage } from './pages/PostPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ScopePage } from './pages/ScopePage';
import { TermsPage } from './pages/TermsPage';

export function App(): ReactNode {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="c/:category" element={<ScopePage />} />
        <Route path="c/:category/:subcategory" element={<ScopePage />} />
        <Route path="jobs/:id" element={<JobPage />} />
        <Route path="companies/:slug" element={<CompanyPage />} />
        <Route path="auth" element={<AuthPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="for-employers" element={<ForEmployersPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route
          path="post"
          element={
            <RequireAuth>
              <PostPage />
            </RequireAuth>
          }
        />
        <Route
          path="post/finish"
          element={
            <RequireAuth>
              <PostFinishPage />
            </RequireAuth>
          }
        />
        <Route
          path="dashboard"
          element={
            <RequireAuth>
              <DashboardPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
